import * as types from './mutation-types'

const state = {
  communications: {
    data: [],
    meta: {
      pagination: {
        total_pages: 0,
      },
    },
  },
  blogEntry: {
    author: {
      attributes : {
        full_name : '',
      },
    },
    categories: {
      data: [],
    },
    attributes: {
      title: '',
      body: '',
      hero_image : '',
      publication_date : '',
      status: '',
      _type : 'BlogEntry',
    },
  },
  sms: {
    author: {
      attributes : {
        full_name : '',
      },
    },
    groupRecipients:{
      data: [],
    },
    memberRecipients:{
      data: [],
    },
    attributes: {
      body: '',
      delivery_date : '',
      status: '',
      _type : 'SMS',
    },
  },
  email: {
    author: {
      attributes : {
        full_name : '',
      },
    },
    groupRecipients:{
      data: [],
    },
    memberRecipients:{
      data: [],
    },
    attributes: {
      subject: '',
      body: '',
      delivery_date : '',
      status: '',
      _type : 'Email',
    },
  },
  sendToGroupsModal : {
    open: false,
  },
  sendToMembersModal : {
    open: false,
  },
  archiveBlogEntryModal : {
    open: false,
    blog: {
      attributes: {
        title: '',
      },
    },
  },
  restoreArchivedCommunicationModal: {
    open: false,
    communication: false,
  },
  deleteBlogEntryModal : {
    open: false,
    blog: {
      attributes: {
        title: '',
      },
    },
  },
  archiveEmailModal : {
    open: false,
    email: {
      attributes: {
        subject: '',
      },
    },
  },
  deleteEmailModal : {
    open: false,
    email: {
      attributes: {
        subject: '',
      },
    },
  },
  archiveSMSModal : {
    open: false,
    sms: {},
  },
  deleteSMSModal : {
    open: false,
    sms: {},
  },
  categories : {
    data : [],
  },
  addCategoriesModal :{
    open: false,
  },
  SMSDeliveries : {
    data: [],
    _links: {},
    meta: {
      pagination :{
        total_pages: false,
        current_page: false,
      },
    },
  },
  EmailDeliveries : {
    data: [],
    _links: {},
    meta: {
      pagination :{
        total_pages: false,
        current_page: false,
      },
    },
  },
    
}

const mutations = {
  [types.COMMUNICATION_SET_COMMUNICATIONS](state, communications) {
    state.communications = communications
  },
  [types.COMMUNICATION_CLOSE_SEND_TO_GROUPS_MODAL](state){
    state.sendToGroupsModal.open = false
  },
  [types.COMMUNICATION_OPEN_SEND_TO_GROUPS_MODAL](state){
    state.sendToGroupsModal.open = true
  },
  [types.COMMUNICATION_CLOSE_SEND_TO_MEMBERS_MODAL](state){
    state.sendToMembersModal.open = false
  },
  [types.COMMUNICATION_OPEN_SEND_TO_MEMBERS_MODAL](state){
    state.sendToMembersModal.open = true
  },
  [types.COMMUNICATION_SET_BLOG_ENTRY](state, BlogEntry){
    state.blogEntry = BlogEntry
  },
  [types.COMMUNICATION_SET_EMAIL](state, Email){
    state.email = Email
  },
  [types.COMMUNICATION_SET_SMS](state, SMS){
    state.sms = SMS
  },
  [types.COMMUNICATION_OPEN_ARCHIVE_BLOG_ENTRY_MODAL](state, blog){
    state.archiveBlogEntryModal.open = true
    state.archiveBlogEntryModal.blog = blog
  },
  [types.COMMUNICATION_CLOSE_ARCHIVE_BLOG_ENTRY_MODAL](state){
    state.archiveBlogEntryModal.open = false
    state.archiveBlogEntryModal.blog = {
      attributes: {
        title: '',
      },
    }
  },
  [types.COMMUNICATION_OPEN_RESTORE_ARCHIVED_COMMUNICATION_MODAL](state, communication) {
    state.restoreArchivedCommunicationModal.open = true
    state.restoreArchivedCommunicationModal.communication = communication
  },
  [types.COMMUNICATION_CLOSE_RESTORE_ARCHIVED_COMMUNICATION_MODAL](state) {
    state.restoreArchivedCommunicationModal.open = false
    state.restoreArchivedCommunicationModal.communication = false
  },
  [types.COMMUNICATION_OPEN_DELETE_BLOG_ENTRY_MODAL](state, blog){
    state.deleteBlogEntryModal.open = true
    state.deleteBlogEntryModal.blog = blog
  },
  [types.COMMUNICATION_CLOSE_DELETE_BLOG_ENTRY_MODAL](state){
    state.deleteBlogEntryModal.open = false
    state.deleteBlogEntryModal.blog = {
      attributes: {
        title: '',
      },
    }
  },
  [types.COMMUNICATION_OPEN_ARCHIVE_EMAIL_MODAL](state, email){
    state.archiveEmailModal.open = true
    state.archiveEmailModal.email = email
  },
  [types.COMMUNICATION_CLOSE_ARCHIVE_EMAIL_MODAL](state){
    state.archiveEmailModal.open = false
    state.archiveEmailModal.email = {
      attributes: {
        subject: '',
      },
    }
  },
  [types.COMMUNICATION_OPEN_DELETE_EMAIL_MODAL](state, email){
    state.deleteEmailModal.open = true
    state.deleteEmailModal.email = email
  },
  [types.COMMUNICATION_CLOSE_DELETE_EMAIL_MODAL](state){
    state.deleteEmailModal.open = false
    state.deleteEmailModal.email = {
      attributes: {
        subject: '',
      },
    }
  },
  [types.COMMUNICATION_OPEN_ARCHIVE_SMS_MODAL](state, sms){
    state.archiveSMSModal.open = true
    state.archiveSMSModal.sms = sms
  },
  [types.COMMUNICATION_CLOSE_ARCHIVE_SMS_MODAL](state){
    state.archiveSMSModal.open = false
    state.archiveSMSModal.sms = {}
  },
  [types.COMMUNICATION_OPEN_DELETE_SMS_MODAL](state, sms){
    state.deleteSMSModal.open = true
    state.deleteSMSModal.sms = sms
  },
  [types.COMMUNICATION_CLOSE_DELETE_SMS_MODAL](state){
    state.deleteSMSModal.open = false
    state.deleteSMSModal.sms = {}
  },
  [types.COMMUNICATION_SET_CATEGORIES](state, categories){
    state.categories = categories
  },
  [types.COMMUNICATION_CLOSE_ADD_CATEGORIES_MODAL](state){
    state.addCategoriesModal.open = false
  },
  [types.COMMUNICATION_OPEN_ADD_CATEGORIES_MODAL](state){
    state.addCategoriesModal.open = true
  },
  [types.COMMUNICATION_SET_SMS_DELIVERIES](state, deliveries){
    state.SMSDeliveries = deliveries
  },
  [types.COMMUNICATION_SET_EMAIL_DELIVERIES](state, deliveries){
    state.EmailDeliveries = deliveries
  },
}

export default {
  state,
  mutations,
}